export default "__VITE_ASSET__DLjEopNe__"